import ImportDashboard from "./pages/dashboard";
import ImportPage from "./pages/import";
import Activities from "./pages/activities";
import SuccessPage from "./pages/thank-you";
import NotFound from "../shares/components2/not-found.vue";

export default [
  {
    path: "*",
    component: NotFound
    },
  {
    path: "/import",
    component: ImportDashboard,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: "thanks",
        name: "import-thanks", 
        component: SuccessPage
      },
      {
        path: "activities",
        component: Activities
      },
      {
        path: "",
        component: ImportPage
      }
    ]
  }
];
